/**
 * SectionTag — colored pill for an Excellent section.
 *
 * Sections have no `color` column in the DB; their color is derived
 * deterministically from the slug via `sectionColor` in
 * `packages/ui/src/tokens/section-colors.ts`. The nine canonical sections
 * (operations, design, hiring, development, marketing, sales,
 * customer-success, finance, legal) each get their OWN vivid hue; any
 * other slug hashes into the section spectrum. The pill tints itself from
 * that hue via the `.section-*` utilities (mode-aware `color-mix`), so the
 * same color shows up here, on the setup banner, and in the rail.
 *
 *   <SectionTag slug="design" name="Design" />
 *   <SectionTag slug={section.slug} name={section.name} />
 *   <Link href="..."><SectionTag slug="design" name="Design" /></Link>
 *
 * Renders as a compact rounded-full tag pill, matching `<StatusBadge>`'s shape.
 */

import * as React from "react";
import { cn } from "../utils";
import { TAG_STYLE } from "../badge";
import { sectionAccentVars } from "../tokens";

export interface SectionTagProps {
  slug: string;
  name: string;
  className?: string;
}

export function SectionTag({ slug, name, className }: SectionTagProps) {
  return (
    <span
      data-slot="section-tag"
      style={sectionAccentVars(slug)}
      className={cn(
        // Layout + section-specific tint/border; size & shape come from the
        // shared TAG_STYLE so section pills match status/intent pills exactly.
        "section-tint section-fg section-border inline-flex w-fit shrink-0 items-center justify-center whitespace-nowrap",
        TAG_STYLE,
        className,
      )}
    >
      {name}
    </span>
  );
}
